'use strict';
import MxExtensionGalleryService from './mx-extension-gallery.service';

export default angular
	.module('mx.sb.ExtensionGallery', [
		/*'mx.shell', 'mx.SolutionBuilderAgent'*/
	])
	.run([
		'mx.shell.RoutingService',
		'mx.sb.ExtensionGalleryService',
		function (routingService, extensionGalleryService) {
			const extensionGalleryRouteName = 'extension-gallery';

			routingService.$transitions.onStart({}, async (transition) => {
				if (transition.to().name === extensionGalleryRouteName) {
					extensionGalleryService.goToExtensionGallery();
					return false;
				}
			});

			const extensionGalleryRoute = routingService.createRoutingItem({
				name: extensionGalleryRouteName,
				path: extensionGalleryRouteName,
			});

			routingService.addItems([extensionGalleryRoute]);
		},
	])
	.service('mx.sb.ExtensionGalleryService', MxExtensionGalleryService).name;
